export default __webpack_public_path__ + "static/Dont-Nesting-8e882e7349dc2405cdaef9bb0c2035cd.png";